// DashboardFlow.tsx
import { useState } from "react";
import DashboardPage from "./DashboardPage";
import CreateReportPage from "../../../components/create-report";
import ReportProcessingPage from "./ReportProcessingPage";

export default function DashboardFlow() {
  const [step, setStep] = useState<"dashboard" | "create" | "processing">("dashboard");
  const [fileData, setFileData] = useState<File | null>(null);
  const [reportTypes, setReportTypes] = useState<{reportType: string; reportType2: string} | null>(null);
  const [_, setReportData] = useState<any | null>(null);

  if (step === "dashboard") {
    return (
      <DashboardPage
        onFileReady={(file, reportType, reportType2) => {
          setFileData(file);
          setReportTypes({ reportType, reportType2 });
          setStep("create");
        }}
      onReportCreated={(report) => {
        setReportData(report);
        setStep("processing");
      }}
      />
    );
  }

  if (step === "create") {
    return (
      <CreateReportPage
        fileData={fileData}
        reportTypes={reportTypes}
        onReportCreated={(report) => {
          setReportData(report);
          setStep("processing");
        }}
      />
    );
  }
  
  if (step === "processing") {
    return <ReportProcessingPage />;
  }

  return null;
}